import { RepositoriesActions } from "../reducers/repositories";

export const { refreshRepositories } = RepositoriesActions;
